$(document).ready(function() {
    /* Select active menu */
    var adress = window.location.pathname;
    first =adress.split('/');
    first = first[1];
    if(adress == '/') {
        $( "#menu > nav > div > .row > div > ul > li > a" ).eq(0).addClass('active');
    } else {
        $("#menu > nav > div > .row > div > ul > li ").each(function (index) {
            
            if ($(this  ).html().indexOf(adress) > 0) {
                console.log(first);
                $( "#menu > nav > .row > div > ul > li > a .active" ).removeClass('active');
                $(this).addClass('active');
                first = null;
                return;
            } else if ($(this).html().indexOf(first) > 0) {
                $(this).addClass('active');
            } 
        });
    } 
    /* next level menu */
    $('.dropdown-submenu a.test').on("click", function(e){
        $(this).next('ul').toggle();
        e.stopPropagation();
        e.preventDefault();
  });
});
//# sourceMappingURL=default.js.map
